import React, { useRef } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
export function ReviewsCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const reviews = [{
    name: 'Michael T.',
    city: 'Harrison Township, MI',
    text: 'Dominic and his team did an incredible job replacing our 20-year-old roof. They were communicative, clean, and finished the job in just two days. Highly recommend Moceri!'
  }, {
    name: 'Sarah J.',
    city: 'Macomb, MI',
    text: 'We hired Moceri for new siding and gutters. The transformation is unbelievable. The crew was respectful of our property and the pricing was very fair compared to other quotes.'
  }, {
    name: 'David R.',
    city: 'Port Huron, MI',
    text: 'After a major storm, we needed emergency roof repairs. Dominic came out the same day to tarp it and worked with our insurance to get the full replacement covered. True professionals.'
  }, {
    name: 'Jennifer L.',
    city: 'Clinton Township, MI',
    text: 'Fantastic experience from start to finish. The new architectural shingles look beautiful and they left the yard spotless. Not a single nail found in the driveway.'
  }, {
    name: 'Robert M.',
    city: 'Sterling Heights, MI',
    text: "Honest, reliable, and skilled. It's hard to find contractors you can trust these days, but Moceri Residential Services exceeded all expectations on our window replacement project."
  }];
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 bg-gray-50 overflow-hidden" data-id="element-387">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-388">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-389">
          <div data-id="element-390">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-391">
              What Our Customers Say
            </h2>
            <div className="w-20 h-1 bg-brand-blue mb-6 rounded-full" data-id="element-392"></div>
            <div className="flex items-center gap-4" data-id="element-393">
              <div className="flex text-yellow-400" data-id="element-394">
                {[...Array(5)].map((_, i) => <Star key={i} size={24} fill="currentColor" data-id="element-395" />)}
              </div>
              <span className="font-body font-bold text-brand-gray-dark" data-id="element-396">
                5.0 Average Rating
              </span>
            </div>
          </div>

          <div className="flex gap-3" data-id="element-397">
            <button onClick={() => scroll('left')} className="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-brand-gray hover:text-brand-blue hover:border-brand-blue transition-colors shadow-sm" data-id="element-398">
              <ChevronLeft size={24} data-id="element-399" />
            </button>
            <button onClick={() => scroll('right')} className="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-brand-gray hover:text-brand-blue hover:border-brand-blue transition-colors shadow-sm" data-id="element-400">
              <ChevronRight size={24} data-id="element-401" />
            </button>
          </div>
        </div>

        {/* Carousel Container */}
        <div ref={scrollRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-8 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-402">
          {reviews.map((review, index) => <div key={index} className="min-w-[300px] md:min-w-[400px] bg-white p-8 rounded-xl shadow-sm border border-gray-100 snap-start flex flex-col" data-id="element-403">
              <div className="flex text-yellow-400 mb-4" data-id="element-404">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-405" />)}
              </div>
              <p className="font-body text-brand-gray italic mb-6 flex-grow" data-id="element-406">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-50" data-id="element-407">
                <div data-id="element-408">
                  <h4 className="font-heading font-bold text-brand-gray-dark" data-id="element-409">
                    {review.name}
                  </h4>
                  <p className="font-body text-xs text-brand-gray" data-id="element-410">
                    {review.city}
                  </p>
                </div>
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-[10px]" data-id="element-411">
                  G
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}